import React from 'react'
import { useNavigate } from 'react-router-dom'
import { TruncatedValue } from '../../../../../common/TruncatedValue'
import { formatSum } from '../../../../../../utils'
import { formatMskDateTime } from '../../Dashboard/core/mskTime'
import { FlowControlRefusalListItem } from '../../../../ticket-card/core/refusal.types'
import { refusalRowUrl } from '../core/consts'

const FlowControlRefusalsTable: React.FC<{ items: FlowControlRefusalListItem[]; loading: boolean }> = ({ items, loading }) => {
  const navigate = useNavigate()

  return (
    <div className='table-responsive'>
      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
        <thead>
          <tr className='fw-bolder text-muted'>
            <th>Время (МСК)</th>
            <th>Стадия</th>
            <th>Мерчант</th>
            <th>ID транзакции</th>
            <th>Метод</th>
            <th className='text-end'>Сумма</th>
            <th>Причина</th>
            <th>Исход</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => (
            <tr key={row.id} style={{ cursor: 'pointer' }} onClick={() => navigate(refusalRowUrl(row))}>
              <td className='text-nowrap'>{formatMskDateTime(row.createdAt)}</td>
              <td>{row.stageTitle}</td>
              <td>{row.merchant}</td>
              <td>
                <TruncatedValue value={row.transactionId} empty='—' />
              </td>
              <td>{row.paymentMethod ?? '—'}</td>
              <td className='text-end text-nowrap'>
                {formatSum(row.amount)} {row.currency ?? ''}
              </td>
              <td>
                <div>{row.reasonTitle}</div>
                <div className='text-muted' style={{ fontSize: 12 }}>
                  {row.summary}
                </div>
              </td>
              <td>{row.outcomeTitle}</td>
            </tr>
          ))}
          {!loading && items.length === 0 && (
            <tr>
              <td colSpan={8} className='text-center text-muted'>
                Отказов нет
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default FlowControlRefusalsTable
